export default __webpack_public_path__ + "static/media/scdream5.744669b5.woff2";